export default{
    en:{
        empNo:'Faculty ID No.',
        korNm:'Name',
        orgtx0:'Affiliation',
        regno:'Date of Birth',
        sessionModal:{
            change:'Change',
        },
        info:{
            empNo: 'Faculty ID No.',
            sex: 'Sex',
            orgtx0: 'Affiliation',
            orgtx1: 'Major',
            zfieldNm: 'Research Field',
            majorTxt: 'Specialization'
        },
    },
    ko:{
        empNo:'교번',
        korNm:'성명',
        orgtx0:'소속',
        regno:'생년월일',
        sessionModal:{
            change:'변경',
        },
        info:{
            empNo: '교원번호',
            sex: '성별',
            orgtx0: '대학(원)',
            orgtx1: '학과(전공)',
            zfieldNm: '업적분야',
            majorTxt: '세부전공'
        },
    },
}